<template>
  <div id="useHelp">
    <!--导航-->
    <topHead style="float: right;position:fixed;z-index: 999;background-color: white;" ref="topHead"></topHead>
    <div style="height: 80px;width: 100%"></div>
    <!--隐私协议-->
    <div class="use-contain">
      <div class="main">
        <el-row class="tac">
          <el-col :span="5" class="menu-bar">
            <ul>
              <li @click="show = !show" :class="{'li-active': ((showData == 1||showData == 2)&& show==false)}">
                <p>安装快点云打印</p>
                <el-icon v-if="show" class="el-icon-arrow-up "></el-icon>
                <el-icon v-if="!show" class="el-icon-arrow-down"></el-icon>
              </li>
              <li v-if="show" @click="showData = 1" :class="{'li-active': showData == 1}"><span>下载快点APP并注册账户</span></li>
              <li v-if="show" @click="showData = 2" :class="{'li-active': showData == 2}"><span>下载安装快点Win客户端</span></li>
            </ul>
            <ul>
              <li @click="showAdd = !showAdd" :class="{'li-active': ((showData == 4||showData == 5)&& showAdd==false)}">
                <p>使用快点云打印</p>
                <el-icon class="el-icon-arrow-up"></el-icon>
                <el-icon class="el-icon-arrow-down block-none"></el-icon>
              </li>
              <li v-if="showAdd" @click="showData = 4" :class="{'li-active': showData == 4}"><span>手机APP直接打印</span></li>
              <li v-if="showAdd" @click="showData = 5" :class="{'li-active': showData == 5}"><span>Win客户端打印</span></li>
              <li v-if="showAdd" @click="showData = 6" :class="{'li-active': showData == 6}"><span>隐私协议</span></li>
            </ul>
          </el-col>
          <el-col :span="18" :offset="1" class="menu-content">
            <article class="menu-text" :class="{'block-none': !(showData == 1)}">
              <!-- <h3>注册规则</h3>-->
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您可以在快点官网首页，下载“快点云打印”APP至您的手机。也可以在您手机自带的应用商店搜索“快点云打印”并安装。</p>
              <p>安装APP后，依照软件提示进行账户注册，这样您就拥有了一个快点账号啦。<span class="watchvideo"
                                                          @click="windowOpen('https://music.163.com/#/mv?id=5342215')"><span
                class="watchvideo" @click="windowOpen('https://music.163.com/#/mv?id=5342215')">查看视频演示</span></span></p>
            </article>
            <article class="menu-text" :class="{'block-none': !(showData == 4)}">
              <!-- <h3>注册规则</h3>-->
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您可以单独使用手机APP进行快点文库中资料（或您的好友分享给您的资料）的打印。点击对应文档后面的打印按钮，该文档就进入“待打印”列表。设置好打印方式，寻找到附近的快点云打印机，扫码连接后，打印机就会给您打印出来啦。<span
                class="watchvideo" @click="windowOpen('https://music.163.com/#/mv?id=5342215')">查看视频演示</span></p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;找到需要打印的文档》点击打印》在“待打印”列表设置打印方式》扫码连接快点云打印机》确认打印。</p>
            </article>
            <article class="menu-text" :class="{'block-none': !(showData == 5)}">
              <!--<h3>关于信息审核</h3>-->
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您可以安装“快点win客户端”，来打印您个人电脑上的资料。安装了“快点win客户端”后，就相当于您的电脑已经配备了一台看不见的打印机。您可以在电脑上任何可以打印的地方（word、ppt、excel等等）点击打印按钮，只要您选择“kd
                clould print”这台打印机，您的手机APP上就出现了“待打印”的文档。按照APP的打印方式就可以将该文档打印出来哦。<span class="watchvideo"
                                                                                     @click="windowOpen('https://music.163.com/#/mv?id=5342215')">查看视频演示</span>
              <p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在电脑上点击打印》在APP“待打印”列表设置打印方式》扫码连接快点云打印机》确认打印。</p>
            </article>
            <article class="menu-text" :class="{'block-none': !(showData == 6)}">
              <div>
                <p style="font-family:宋体; font-size:16pt;text-align: center">快点云打印用户隐私政策</p>
                <div>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;贵州快点在线科技服务有限公司是快点云打印平台（以下简称“快点云打印”或“我们”）的运营者，
                    本《隐私政策》（以下简称“本政策”）阐述了快点云打印将如何处理您的个人信息和隐私信息，
                    并申明了快点云打印对保护隐私的承诺，快点云打印未来有可能根据信息处理情境不时更新或修改本政策。
                    请您在向快点云打印提交个人信息或隐私信息之前，阅读、了解并同意本政策和任何补充政策。本隐私政策要点如下∶</p>

                </div>
                <!--<h3>关于信息审核</h3>-->
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;快点云打印尊重并保护所有使用服务用户的个人隐私权。为了给您提供更优质的服务，快点云打印会按照本隐私权政策的规定使用和披露您的个人信息。
                  但快点云打印将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，快点云打印不会将这些信息对外披露或向第三方提供。
                  快点云打印会不时更新本隐私权政策。您在同意快点云打印服务使用协议之时，即视为您已经同意本隐私权政策全部内容。
                  本隐私权政策属于快点云打印服务使用协议不可分割的一部分。</p>
                <p>1.适用范围</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a) 在您注册快点云打印帐号时，您根据快点云打印要求提供的个人注册信息；</p>

                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;b)
                  在您使用快点云打印网络服务，或访问快点云打印平台网页时，快点云打印自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；</p>

                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;c) 快点云打印通过合法途径从商业伙伴处取得的用户个人数据。</p>

                <p> 您了解并同意，以下信息不适用本隐私权政策：</p>

                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a) 您在使用快点云打印平台提供的搜索服务时输入的关键字信息；</p>

                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;b) 快点云打印收集到的您在快点云打印发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情；</p>

                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;c) 违反法律规定或违反快点云打印规则行为及快点云打印已对您采取的措施。</p>

                <p> 2.信息使用</p>

                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a)
                  快点云打印不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和快点云打印（含快点云打印关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。</p>

                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;b)
                  快点云打印亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何快点云打印平台用户如从事上述活动，一经发现，快点云打印有权立即终止与该用户的服务协议。</p>

                <div style="font-weight: bold">
                  <p>3.信息披露</p>
                  <p>在如下情况下，快点云打印将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>

                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a) 经您事先同意，向第三方披露；</p>

                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</p>

                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>

                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;d) 如您出现违反中国有关法律、法规或者快点云打印服务协议或相关规则的情况，需要向第三方披露；</p>

                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;e) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；</p>

                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;f)
                    在快点云打印平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，快点云打印有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。

                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;g) 其它快点云打印根据法律、法规或者网站政策认为合适的披露。</p>
                </div>
                <p>4.收集信息的第三方应用</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为了给用户提供更好的体验，快云打印内集成了华为推送、阿里推送、阿里号码认证SDK、com.alipay(支付宝;mPaaS;阿里乘车码;阿里芝麻信用实名认证;芝麻认证)、
                  com.heytap.msp(OPPO;OPush), com.xiaomi.push(小米;小米推送), com.aliyun(阿里云;阿里push;阿里推送;mPaaS),com.hihonor.push(荣耀推送), com.vivo.push(vivo推送)
                  com.cmic.sso(移动;中国移动), com.igexin.push(个推;个验;个像),个推、个验、个像]SDK获取BSSID，SSID个人信息,
                  com.heytap.msp(OPPO;OPush), com.aliyun(阿里云;阿里push;阿里推送;mPaaS), com.xiaomi.push(小米;小米推送),
                  com.mobile.auth(一键登录;阿里云号码认证), com.cmic.sso(移动;中国移动), com.alipay(支付宝;mPaaS;阿里乘车码;阿里芝麻信用实名认证;芝麻认证),
                  com.igexin.push(个推;个验;个像),等SDK。关于第三方SDK的使用，以下几点望你知晓</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1 华为推送、阿里推送、OPush等推送相关的SDK是为了实时通知APP侧文档的打印结果、周边设备的可用情况等</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2 号码认证SDK是为了提供便利的一键登录服务</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3 为了记录您在使用过程中碰到的软件运行远程的错误具体信息，APP内集成了腾讯BuglySDK,SDK会收集您的设备ID,IMSI和ANDROID
                  ID。以上相关信息，不会在未经您允许的情况下分享给其他第三方平台</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4 安卓端处理的信息：
                  （1）设备信息、网络信息：必选信息：设备平台、设备厂商、设备品牌、设备型号及系统版本、OAID、AndroidID、WIFI连接信息、运营商信息
                  可选信息：IMEI、MAC、Google Advertising ID（GAID）、Serial Number、IMSI、ICCID、IP地址、基站信息。用于生成唯一的推送目标ID（CID）和设备ID（GID），以此保证消息推送的准确下发和消息设备的准确识别。
                  （2）位置相关信息：应景推送、智能推送和应急推送扩展功能的必选信息，提供线下场景的精细化推送，可以为您推荐更符合您需要的推送内容，减少无用推送消息对您的打扰。应国家有关部门要求，为了提升移动互联网技术服务社会公益的功能，发挥 APP 消息推送在灾害预警方面的作用，当发生地震及气象等重大灾害时，通过开发者的APP 推送通道实时向受影响地区的用户下发相关的灾害通知信息
                  （3）应用列表信息：智能推送、应急推送和链路调节器扩展功能的必选信息，推荐更符合您需要的推送内容，减少无用推送信息对您的打扰。应国家有关部门要求，为了提升移动互联网技术服务社会公益的功能，发挥 APP 消息推送在灾害预警方面的作用，当发生地震及气象等重大灾害时，通过开发者的APP 推送通道实时向受影响地区的用户下发相关的灾害通知信息。我们采⽤合并链路技术进⾏技术推送，当⼀个设备有多个APP的推送链路同时活跃时，我们会随机合并成⼀条链路，以达到为您省电省流量的⽬的，当一个设备有离线推送消息待下发的场景时，通过关联启动功能可以下发离线消息，您可以选择开启或关闭这项服务，当您关闭这项服务时，关联启动也同时会关闭，会导致电量和流量消耗加大的同时消息触达率也会降低。
                  iOS端处理的信息：
                  （1）设备信息：设备识别码（IDFA、IDFV）、设备平台、设备厂商用于生成唯一的推送目标ID（CID）和设备ID（GID），以此保证消息推送的准确下发和消息设备的准确识别。设备品牌、设备型号及系统版本用于优化通道资源的有效性，提升消息推送的到达率和稳定性。 （2）网络信息（包含IP地址、WIFI信息、基站信息、运营商信息）以及位置相关信息：为了最大程度保持网络连接的稳定性，建立长链接，我们需要了解设备的网络状态和变化，从而实现稳定连续的推送服务。我们提供应景推送功能，位置相关信息将有助于我们为您提供线下场景的精细化推送，可以为您推荐更符合您需要的推送内容，减少无用推送消息对您的打扰。 为保障我们推送服务的稳定运行、功能实现，使您能够使用和享受更多的功能及服务，我们的服务中会接入由合作方提供的软件开发工具包（SDK）、应用程序接口（API）[1] 。我们会对合作方获取信息的软件开发工具包（SDK）、应用程序接口（API）[2] 进行严格的安全检测，并与合作方约定严格的数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息。我们接入合作方详情如下，我们建议您阅读相关的隐私政策：
                  SDK名称：卓信ID
                  涉及信息：设备弱特征（不具备唯一性和稳定性的特征）:设备信息(设备制造商、设备型号、设备系统信息)、设备网络信息(设备联网方式和状态信息)、设备环境信息(屏幕亮度、电池状态及所在国家、设备应用信息（设备常见应用的版本等安装信息）
                  使用目的：提供设备标识与安全风控服务
                  合作方主体：中国信息通信研究院
                  收集方式：SDK收集
                  合作方官网链接：https://zxid.caict.ac.cn
                  合作方隐私政策链接：https://zxid.caict.ac.cn/privacy</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5 快点云打印和集成的SDK获取到您的设备的相关信息，仅在快点云打印APP内使用。不会在未经您允许的情况下分享给其他第三方平台</p>

                <p>5.手机权限说明</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;应用内集成了第三方广告，会获取相关权限和执行以下操作，请知晓</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. 设备品牌、设备型号、设备时区、设备语言、系统版本、开发者应用名、应用版本号、应用包名、网络类型、UserAgent信息、网络状态、崩溃信息、性能数据、屏幕高宽、屏幕方向、屏幕DPI信息、系统更新时间、开机时间、USB调试模式、运营商、sim卡状态、cpu、应用的进程名称、应用的进程信息、运行状态、磁盘空间、物理内存。设备ID（OAID、GAID）（IMEI 用户授权才收集）。设备ID（IDFA 用户授权才收集）、IDFV。访问互联网、网络状态、手机WiFi状态、安装应用。网络权限、设备信息（IDFA）</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;详细隐私内容，可访问第三方隐私政策地址查看：<a href="http://sdkdoc.beizi.biz/#/zh-cn/guide/UsePrivacy" target="_blank">《BeiZi隐私政策》http://sdkdoc.beizi.biz/#/zh-cn/guide/UsePrivacy</a>。</p>
                <p>6.手机权限说明</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为了给用户提供更好的体验，快云打印需要获取您手机的以下权限，请知晓</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. 允许应用读取或修改或删除存储卡上的照片、媒体内容和文件。</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2. 允许应用基于GPS、基站、 Wi-Fi 等网络源获取位置信息。这可能会增加耗电量。</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3. 允许应用基于基站、 Wi-Fi 等网络源获取位置信息。</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4. 允许应用使用相机拍摄照片和录制视频。</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5. 允许应用获取本机的照片和视频。</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6. 允许应用获取本机号码、通话状态以及拨打的号码。</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7. 允许应用获取本机的软件安装列表。</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8. 允许应用获取获取MAC地址,位置信息,存储权限,ANDROID ID个人信息。</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;快点云打印获取照片、媒体内容和文件是为上传打印文件。访问GPS、WiFi等信息是为了根据你的位置匹配当地的优惠信息。使用拍照是为了扫码连接打印机</p>
                <p>7.儿童保护说明</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在使用我们的各项产品和服务（以下简称“服务”或“游戏”）前，请儿童、儿童的父母或其他监护人（以下统称“监护人”）务必仔细阅读并透彻理解本政策，特别是以粗体/下划线标识的条款应重点阅读，在确认充分理解并同意全部条款后再开始使用。
                  监护人特别说明：
                  若您的孩子不满十四周岁，我们将根据本政策采取特殊措施保护我们获得的您孩子的个人信息。请帮助我们保护您孩子的个人信息和隐私安全，要求他们在您的监护下共同阅读并接受本政策，且应在您的同意和指导下使用来来服务、提交个人信息。
                  如果您不同意本政策的内容，将可能导致服务无法正常运行，或者无法达到我们拟达到的服务效果，您应要求您的孩子立即停止访问/使用服务。
                  您于线上点击同意本政策，或者您的孩子使用/继续使用服务、提交个人信息，都表示您同意我们按照本政策（包括更新版本）收集、使用、存储、共享、转让和披露您孩子的个人信息。
                  儿童特别说明：
                  任何儿童参加网上活动都应事先取得监护人的同意。如果您是儿童，请通知您的监护人共同阅读本政策，并在您使用服务、提交个人信息之前，寻求您的监护人的同意和指导。
                  您于线上点击同意本政策，或者您使用/继续使用服务、提交个人信息，都表示您已获得您的监护人的许可，您的监护人均同意我们按照本政策（包括更新版本）收集、使用、存储、共享、转让和披露您的个人信息。</p>

                <div style="font-weight: bold">

                  <p>7.其他</p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1 在您进行登录之前，请先仔细阅读隐私协议，确认误会，勾选同意单选框后在进行登录</p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2 我们会逐一说明我们对个人信息收集、使用、保护等处理的情况，以便您能够了解个人信息的概况。
                  </p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3
                    当您注册快点云打印帐号和使用我们的服务时，我们会根据您的同意和提供服务的需要，收集您的姓名、性别、年龄、个人资料照片或视频、身份证号、电话号码、电子邮件、社交帐号、身份验证信息、位置信息和日志信息等个人信息。
                  </p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4 除了产品的核心功能外，快点云打印提供一些附加功能来提升用户体验，包括∶
                  </p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5
                    消息设置、邮件设置、推送通知设置、快点云打印衍生服务等。当您使用快点云打印的附加功能时，我们不会额外收集您的个人信息，除非根据本政策告知并取得您的同意。
                  </p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6 为了方便您查阅过往信息，我们需要获取您的MAC地址和设备号码（IMEI）以便记录存档。
                    目前，除法律法规、法律程序、诉讼或政府主管部门强制性要求外，快点云打印平台不会主动公开披露您的个人信息，如果存在其他需要公开披露个人信息的情形，我们会征得您的明示同意。同时，我们保证披露采取符合法律和业界标准的安全防护措施。
                  </p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7 您可以通过本隐私政策所列的途径访问、更正或删除您的个人信息，也可以进行隐私设置或与我们取得联系。
                    您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存、共享、转让和公开披露您的相关信息。
                  </p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8
                    关于自启动和关联启动说明：为确保本应用处于关闭或后台运营状态下可正常接收到客户端推送的互动信息，本应用须使用（自启动）能力，将存在一定频率通过形同发送互动信息唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的，在征得您的明确同意后，会打开相关内容。在未征得您同意的情况下，则不会有关联启动。。</p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9 账号有效性。账号自注册登录起终身有效。若需要注销账号，请联系官方客服处理：17586184555。接听时间：09:00~18:00（工作日）。
                  </p>
                </div>
                <p>2023年12月12日</p>
              </div>
            </article>
          </el-col>
        </el-row>
      </div>
    </div>
    <!--底部-->
    <bottom ref="bottom"></bottom>
  </div>
</template>

<script>
import bottom from './common/Bottom'
import topHead from './common/TopHead'
import * as Api from '../assets/js/Api'

export default {
  data () {
    return {
      show: true,
      showAdd: true,
      showData: 6
    }
  },
  created () {
    Api.changeClass = 1
  },
  components: {
    bottom: bottom,
    topHead: topHead
  },
  methods: {
    // 打开外链
    windowOpen (url) {
      window.open(url)
    }
  }
}
</script>

<style>
.watchvideo {
  cursor: pointer;
  color: blue;
}

.nav-content {
  width: 100%;
  height: 80px;
}

.logo-contain {
  float: left;
  padding-top: 15px;
}

.logo-set {
  width: auto;
  height: 50px;
  vertical-align: center;
  margin-right: 10px;
}

.logo-text {
  display: inline-block;
  text-align: left;
  vertical-align: top;
}

.logo-text p {
  font-size: 20px;
  color: #333;
}

.logo-text small {
  font-size: 14px;
  color: #999;
}

.nav-list {
  float: right;
}

.nav-list li {
  display: inline-block;
  height: 50px;
  width: 150px;
}

.nav-list li a {
  border-bottom: 2px solid #fff;
  width: 100px;
  color: #333;
  font-size: 16px;
  line-height: 78px;
}

.nav-list li a:hover {
  color: #f62828;
  border-bottom: 2px solid #f62828;
}

.nav-list li .a-active {
  color: #f62828;
  border-bottom: 2px solid #f62828;
}

.main {
  width: 1200px;
}

.use-contain {
  width: 100%;
  background-color: #f5f5f5;
  padding: 30px 0px;
}

.menu-bar {
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 3px 5px 10px -2px rgba(0, 0, 0, 0.09),
  -3px -5px 10px -2px rgba(0, 0, 0, 0.09);
  padding: 20px 0px;
}

.menu-bar li {
  padding: 0px 40px;
  text-align: left;
  height: 50px;
  line-height: 50px;
  cursor: pointer;
}

.menu-bar li:hover {
  background-color: #f62828;
  color: #fff;
}

.menu-bar .li-active {
  background-color: #f62828;
  color: #fff;
}

.menu-bar li p {
  font-size: 18px;
  display: inline-block;
}

.menu-bar li i {
  float: right;
  line-height: 50px;
}

.menu-bar li span {
  padding-left: 15px;
  font-size: 14px;
}

.menu-content {
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 3px 5px 10px -2px rgba(0, 0, 0, 0.09),
  -3px -5px 10px -2px rgba(0, 0, 0, 0.09);
  min-height: 650px;
  padding: 30px;
}

.menu-text {
  text-align: left;
}

.menu-text h3 {
  font-size: 16px;
  color: #333;
  line-height: 40px;
}

.menu-text p {
  font-size: 14px;
  color: #444;
  line-height: 30px;
}

.common-bottom {
  width: 100%;
  background-color: #434343;
  color: rgba(255, 255, 255, 0.8);
  text-align: left;
  padding: 30px 0px;
}

.block-none {
  display: none;
}

.bottom-ul h5 {
  font-size: 18px;
  font-weight: normal;
  width: 50%;
  border-bottom: 1px solid #fff;
  padding-bottom: 10px;
  margin-bottom: 10px;
  margin-left: 0px;
}

.bottom-ul a, .bottom-ul span {
  font-size: 14px;
  line-height: 25px;
}

.bottom-ul span {
  margin-left: 5px;
}

.bottom-ul a {
  color: rgba(255, 255, 255, 0.8);
}

.bottom-ul a:hover {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: underline;
}

.code-set {
  width: 120px;
  height: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/Privacy.vue